"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.cssAnchorName = void 0;

var _preact = require("preact");

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _qs = _interopRequireDefault(require("qs"));

var _classnames = _interopRequireDefault(require("classnames"));

var _components = require("@insided/shared/services/algolia/components");

var _algolia = require("@insided/shared/services/algolia");

var _algoliaService = require("@insided/deprecated-services/algoliaService");

var _common = require("@insided/shared/utils/common");

var _SearchBox = _interopRequireDefault(require("./SearchBox"));

var _Results = require("./Results");

var _Indexes = _interopRequireDefault(require("./Indexes"));

var _Sidebar = require("./Sidebar");

var _FilterTabs = _interopRequireDefault(require("./FilterTabs"));

var _utils = require("./utils");

var _components2 = require("../../components");

var _SmartSummary = _interopRequireDefault(require("./SmartSummary"));

var _ForethoughtAgent = _interopRequireDefault(require("./ForethoughtAgent"));

var _phrase = _interopRequireDefault(require("@insided/deprecated-libs/translationsUtils/phrase"));

var _utils2 = require("../../utils");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var createURL = function createURL(state) {
  return "?".concat(_qs.default.stringify(state));
};

/**
 * Pulls the hero's pre-filter IDs out of the URL. Coerces single values to
 * arrays for downstream consistency (`qs.parse('publishedIn=1')` returns a
 * string, not a one-element array). Returns `undefined` for empty so
 * `getFilters` can early-out on falsy.
 */
function extractHeroFilters(stateInUrl) {
  var rawPublishedIn = stateInUrl.publishedIn;
  var rawProductArea = stateInUrl.productArea;
  var publishedIn = rawPublishedIn ? (Array.isArray(rawPublishedIn) ? rawPublishedIn : [rawPublishedIn]).map(function (v) {
    return Number(v);
  }).filter(function (n) {
    return Number.isFinite(n);
  }) : undefined;
  var productArea = rawProductArea ? (Array.isArray(rawProductArea) ? rawProductArea : [rawProductArea]).filter(function (v) {
    return typeof v === 'string' && v !== '';
  }) : undefined;
  return {
    searchInContentCategories: publishedIn && publishedIn.length > 0 ? publishedIn : undefined,
    searchInProductAreas: productArea && productArea.length > 0 ? productArea : undefined
  };
}

var searchStateToUrl = function searchStateToUrl(searchState, heroFilters) {
  var _heroFilters$searchIn, _heroFilters$searchIn2, _searchState$refineme, _searchState$hierarch, _searchState$hierarch2, _searchState$hierarch3, _searchState$refineme2, _searchState$refineme3, _searchState$refineme4, _searchState$refineme5;

  var location = window.location;
  if (!searchState) return '';
  var stateToStoreInUrl = {}; // Preserve hero pre-filters across sidebar/search-state writes. Without
  // this, the first sidebar interaction rewrites the URL using only the
  // Algolia searchState fields and the original `publishedIn` /
  // `productArea` params from the redirect get dropped — so the user's
  // "Published in" scoping would silently disappear after one click.

  if (heroFilters !== null && heroFilters !== void 0 && (_heroFilters$searchIn = heroFilters.searchInContentCategories) !== null && _heroFilters$searchIn !== void 0 && _heroFilters$searchIn.length) {
    stateToStoreInUrl.publishedIn = heroFilters.searchInContentCategories.map(String);
  }

  if (heroFilters !== null && heroFilters !== void 0 && (_heroFilters$searchIn2 = heroFilters.searchInProductAreas) !== null && _heroFilters$searchIn2 !== void 0 && _heroFilters$searchIn2.length) {
    stateToStoreInUrl.productArea = heroFilters.searchInProductAreas;
  }

  if (searchState.query) {
    stateToStoreInUrl.q = searchState.query;
  }

  if ((_searchState$refineme = searchState.refinementList) !== null && _searchState$refineme !== void 0 && _searchState$refineme.tags) {
    stateToStoreInUrl.tags = searchState.refinementList.tags;
  }

  if ((_searchState$hierarch = searchState.hierarchicalMenu) !== null && _searchState$hierarch !== void 0 && _searchState$hierarch['categories.lvl0']) {
    stateToStoreInUrl.category = searchState.hierarchicalMenu['categories.lvl0'];
  }

  if ((_searchState$hierarch2 = searchState.hierarchicalMenu) !== null && _searchState$hierarch2 !== void 0 && _searchState$hierarch2['kb.categories.lvl0']) {
    stateToStoreInUrl.kb_category = searchState.hierarchicalMenu['kb.categories.lvl0'];
  }

  if ((_searchState$hierarch3 = searchState.hierarchicalMenu) !== null && _searchState$hierarch3 !== void 0 && _searchState$hierarch3['product_area.lvl0']) {
    stateToStoreInUrl.product_area = searchState.hierarchicalMenu['product_area.lvl0'];
  }

  if ((_searchState$refineme2 = searchState.refinementList) !== null && _searchState$refineme2 !== void 0 && _searchState$refineme2.content_type) {
    stateToStoreInUrl.content_type = searchState.refinementList.content_type;
  }

  if ((_searchState$refineme3 = searchState.refinementList) !== null && _searchState$refineme3 !== void 0 && _searchState$refineme3.source) {
    stateToStoreInUrl.source = searchState.refinementList.source;
  }

  if ((_searchState$refineme4 = searchState.refinementList) !== null && _searchState$refineme4 !== void 0 && _searchState$refineme4.gs_data_source) {
    stateToStoreInUrl.gs_data_source = searchState.refinementList.gs_data_source;
  }

  if ((_searchState$refineme5 = searchState.refinementList) !== null && _searchState$refineme5 !== void 0 && _searchState$refineme5.locale) {
    stateToStoreInUrl.locale = searchState.refinementList.locale;
  }

  var zendeskLocale = (0, _utils.getZendeskLocaleBySearchState)(searchState);

  if (zendeskLocale) {
    stateToStoreInUrl.zendeskLocale = zendeskLocale;
  }

  return "".concat(location.pathname).concat(createURL(stateToStoreInUrl));
};

function asArray(s) {
  if (!s) return [];
  return typeof s === 'string' ? [s] : s;
}

var urlToSearchState = function urlToSearchState(_ref) {
  var _stateInUrl$q2, _stateInUrl$tags, _stateInUrl$gs_data_s, _stateInUrl$locale, _stateInUrl$category, _stateInUrl$kb_catego, _stateInUrl$product_a;

  var search = _ref.search;

  var stateInUrl = _qs.default.parse(search.slice(1));

  if (stateInUrl.search_type === 'tag' && stateInUrl.q) {
    var _stateInUrl$q;

    return {
      query: '',
      refinementList: {
        tags: [(_stateInUrl$q = stateInUrl.q) !== null && _stateInUrl$q !== void 0 ? _stateInUrl$q : ''],
        content_type: [],
        source: [],
        gs_data_source: [],
        locale: []
      },
      indices: {}
    };
  }

  var state = {
    query: (_stateInUrl$q2 = stateInUrl.q) !== null && _stateInUrl$q2 !== void 0 ? _stateInUrl$q2 : '',
    refinementList: {
      tags: (_stateInUrl$tags = stateInUrl.tags) !== null && _stateInUrl$tags !== void 0 ? _stateInUrl$tags : [],
      content_type: stateInUrl.content_type ? stateInUrl.content_type : [],
      source: asArray(stateInUrl.source),
      gs_data_source: (_stateInUrl$gs_data_s = stateInUrl.gs_data_source) !== null && _stateInUrl$gs_data_s !== void 0 ? _stateInUrl$gs_data_s : [],
      locale: (_stateInUrl$locale = stateInUrl.locale) !== null && _stateInUrl$locale !== void 0 ? _stateInUrl$locale : []
    },
    hierarchicalMenu: {
      'categories.lvl0': (_stateInUrl$category = stateInUrl.category) !== null && _stateInUrl$category !== void 0 ? _stateInUrl$category : '',
      'kb.categories.lvl0': (_stateInUrl$kb_catego = stateInUrl.kb_category) !== null && _stateInUrl$kb_catego !== void 0 ? _stateInUrl$kb_catego : '',
      'product_area.lvl0': (_stateInUrl$product_a = stateInUrl.product_area) !== null && _stateInUrl$product_a !== void 0 ? _stateInUrl$product_a : ''
    },
    indices: {}
  };

  if (stateInUrl.zendeskLocale) {
    var _stateInUrl$zendeskLo;

    state.indices = (0, _defineProperty2.default)({}, "".concat(COMMUNITY_ID, "-zendesk"), {
      refinementList: {
        locale: (_stateInUrl$zendeskLo = stateInUrl.zendeskLocale) !== null && _stateInUrl$zendeskLo !== void 0 ? _stateInUrl$zendeskLo : []
      }
    });
  }

  return state;
};

var COMMUNITY_ID = (0, _utils2.getCommunityId)(); // Unified index is always enabled

var DEFAULT_INDEXES = ["".concat(COMMUNITY_ID, "-unified")];

var isFederatedSearchEnabled = function isFederatedSearchEnabled() {
  return _common.common.isModuleActive('federatedSearchApi');
};

var InstantSearchComponent = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(InstantSearchComponent, _Component);

  var _super = _createSuper(InstantSearchComponent);

  function InstantSearchComponent() {
    var _this;

    (0, _classCallCheck2.default)(this, InstantSearchComponent);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "debouncedSetState", 0);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "heroFilters", extractHeroFilters(_qs.default.parse(window.location.search.slice(1))));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "state", {
      client: null,
      enableLoader: false,
      pageCount: 0,
      searchState: urlToSearchState(location),
      isFiltersOverlay: false,
      totalAmount: {
        community: 0,
        zendesk: 0,
        salesforce: 0,
        skilljar: 0,
        freshdesk: 0,
        totalTopics: 0
      },
      isKnowledgeBaseActive: _common.common.isModuleActive('knowledgeBase'),
      // Always render all sources (show unrefined sources as well)
      sourceTabs: {},
      listIndexes: [],
      isZendeskFederatedSearch: false,
      hiddenCategories: []
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleStateChange", function (updatedSearchState) {
      var _searchState$hierarch4;

      clearTimeout(_this.debouncedSetState); // eslint-disable-next-line react/no-access-state-in-setstate

      var searchState = _objectSpread(_objectSpread({}, _this.state.searchState), updatedSearchState); // Detect if a category is selected in hierarchicalMenu


      var selectedCategory = (_searchState$hierarch4 = searchState.hierarchicalMenu) === null || _searchState$hierarch4 === void 0 ? void 0 : _searchState$hierarch4['categories.lvl0'];

      var isProductUpdateEnabled = _common.common.isModuleActive('categoriesV2IdeasAndPU');

      var isIdeationEnabled = _common.common.isModuleActive('categoriesV2IdeasAndPU');

      if (!searchState.refinementList) {
        searchState.refinementList = {
          tags: [],
          content_type: [],
          source: [],
          locale: [],
          gs_data_source: []
        };
      } // Handle filtering based on category + feature flags


      if (selectedCategory && (!isProductUpdateEnabled || !isIdeationEnabled)) {
        if (!searchState.refinementList.content_type) {
          searchState.refinementList.content_type = [];
        }

        if (!isProductUpdateEnabled) {
          // check if -productUpdate exists, if not, add it
          if (!searchState.refinementList.content_type.includes('-productUpdate')) {
            searchState.refinementList.content_type.push('-productUpdate');
          }
        }

        if (!isIdeationEnabled) {
          // check if -ideation exists, if not, add it
          if (!searchState.refinementList.content_type.includes('-ideation')) {
            searchState.refinementList.content_type.push('-ideation');
          }
        }
      } else {
        // When category unselected → remove both exclusions
        searchState.refinementList.content_type = (searchState.refinementList.content_type || []).filter(function (f) {
          return f !== '-productUpdate' && f !== '-ideation';
        });
      }

      _this.debouncedSetState = window.setTimeout(function () {
        history.pushState(searchState, '', searchStateToUrl(_this.state.searchState, _this.heroFilters));
      }, 400);
      var pageChanged = searchStateToUrl(_this.state.searchState, _this.heroFilters) === searchStateToUrl(searchState, _this.heroFilters);

      if (!pageChanged) {
        _this.setState({
          pageCount: 0
        });
      }

      _this.setState({
        searchState: searchState
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleFilterChange", function () {
      _this.setState(function (state) {
        return {
          isFiltersOverlay: !state.isFiltersOverlay
        };
      });

      var bodyEl = document.querySelector('body');

      if (bodyEl) {
        if (bodyEl.style.overflow === 'hidden') {
          bodyEl.style.overflow = 'visible';
        } else {
          bodyEl.style.overflow = 'hidden';
        }
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "clearSidebarFilters", function () {
      _this.setState(function (state) {
        var _state$searchState$re, _state$searchState$re2, _state$searchState$re3, _state$searchState$re4;

        return {
          searchState: _objectSpread(_objectSpread({}, state.searchState), {}, {
            refinementList: {
              tags: [],
              content_type: [],
              source: ((_state$searchState$re = (_state$searchState$re2 = state.searchState.refinementList) === null || _state$searchState$re2 === void 0 ? void 0 : _state$searchState$re2.source) !== null && _state$searchState$re !== void 0 ? _state$searchState$re : []).filter( // We just want to clear community and knowledge_base sources because they are part of sidebar filters.
              // Other sources like zendesk, salesforce, etc. are part of tabs.
              function (item) {
                return !['community', 'knowledge_base'].includes(item);
              }),
              gs_data_source: (_state$searchState$re3 = (_state$searchState$re4 = state.searchState.refinementList) === null || _state$searchState$re4 === void 0 ? void 0 : _state$searchState$re4.gs_data_source) !== null && _state$searchState$re3 !== void 0 ? _state$searchState$re3 : [],
              locale: []
            },
            hierarchicalMenu: {
              'categories.lvl0': '',
              'kb.categories.lvl0': '',
              'product_area.lvl0': ''
            },
            indices: {}
          })
        };
      }, function () {
        // eslint fix for no-restricted-syntax
        // we are updating the state directly, so we need to call the handleStateChange manually
        _this.handleStateChange(_this.state.searchState);
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onAllResultsSectionClick", function (type, value) {
      _this.setState({
        searchState: _objectSpread(_objectSpread({}, _this.state.searchState), {}, {
          // @ts-expect-error
          refinementList: _objectSpread(_objectSpread({}, _this.state.searchState.refinementList), {}, (0, _defineProperty2.default)({}, type, [value]))
        })
      }, function () {
        // eslint fix for no-restricted-syntax
        _this.handleStateChange(_this.state.searchState);

        window.scrollTo(0, 0);
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "totalTopicsAmount", function (totalAmount) {
      if (JSON.stringify(_this.state.totalAmount) !== JSON.stringify(totalAmount)) {
        _this.setState({
          // eslint: fix for object-shorthand
          totalAmount: totalAmount
        });
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onFilterTabChange", function (item) {
      var _currentRefinementLis3, _currentRefinementLis4;

      // When switching tabs, preserve existing sidebar filters (content_type, tags, categories, product_area, etc.)
      // Only clear the tab-specific filters (gs_data_source, source) and set the new one
      var currentRefinementList = _this.state.searchState.refinementList;

      if (!item) {
        var _currentRefinementLis, _currentRefinementLis2;

        // User clicked on "All Results" tab - clear only tab-specific filters, preserve others
        _this.handleStateChange({
          refinementList: {
            tags: (_currentRefinementLis = currentRefinementList === null || currentRefinementList === void 0 ? void 0 : currentRefinementList.tags) !== null && _currentRefinementLis !== void 0 ? _currentRefinementLis : [],
            content_type: (_currentRefinementLis2 = currentRefinementList === null || currentRefinementList === void 0 ? void 0 : currentRefinementList.content_type) !== null && _currentRefinementLis2 !== void 0 ? _currentRefinementLis2 : [],
            source: [],
            gs_data_source: [],
            locale: []
          },
          indices: {}
        });

        return;
      } // Preserve existing filters (tags, content_type, etc.) and only update tab-specific ones


      var refinementList = {
        tags: (_currentRefinementLis3 = currentRefinementList === null || currentRefinementList === void 0 ? void 0 : currentRefinementList.tags) !== null && _currentRefinementLis3 !== void 0 ? _currentRefinementLis3 : [],
        content_type: (_currentRefinementLis4 = currentRefinementList === null || currentRefinementList === void 0 ? void 0 : currentRefinementList.content_type) !== null && _currentRefinementLis4 !== void 0 ? _currentRefinementLis4 : [],
        source: [],
        gs_data_source: [],
        locale: []
      };

      switch (item.type) {
        case 'gs_data_source':
          refinementList.gs_data_source = [item.label];
          break;

        case 'source':
          refinementList.source = [item.label];
          break;

        default:
          break;
      }

      _this.handleStateChange({
        refinementList: refinementList,
        indices: {}
      });
    });
    return _this;
  }

  (0, _createClass2.default)(InstantSearchComponent, [{
    key: "cb",
    value: function () {
      var _cb = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee3(response) {
        var _this$state$searchSta,
            _this2 = this;

        var _yield$Promise$all, _yield$Promise$all2, client, _basicClient, indexNames, isTokenRefresh, originalSearch, searchState, lastRequestKey, lastResponsePromise, emptyQueryCache, hasReceivedQuerySearch, initialUrlQuery;

        return _regenerator.default.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return Promise.all([(0, _algolia.createAlgoliaClient)(response.client_id, response.token), (0, _algolia.createAlgoliaClient)(response.client_id, response.basicToken)]);

              case 2:
                _yield$Promise$all = _context3.sent;
                _yield$Promise$all2 = (0, _slicedToArray2.default)(_yield$Promise$all, 2);
                client = _yield$Promise$all2[0];
                _basicClient = _yield$Promise$all2[1];
                // Use pre-computed availableIndexes from backend (unified index is always enabled)
                indexNames = response.availableIndexes && response.availableIndexes.length > 0 ? response.availableIndexes : DEFAULT_INDEXES;
                this.setState({
                  listIndexes: []
                }); // Track if this is a token refresh - first search after refresh should disable analytics

                isTokenRefresh = response.isTokenRefresh === true;
                originalSearch = client.search.bind(client); // Create a mutable flag that persists across searches for this client instance

                searchState = {
                  disableAnalyticsForNextSearch: isTokenRefresh
                }; // Deduplicate identical consecutive searches caused by Preact re-renders

                lastRequestKey = null;
                lastResponsePromise = null; // Separate cache for empty-query searches to prevent duplicate Algolia calls from Preact re-renders.
                // Stores the full Algolia response (before tab facet slicing) so extractAndSetTabFacets
                // can be called on cache hit.

                emptyQueryCache = null; // Track whether a real (non-empty) search has fired yet.
                // Used to skip spurious empty-query searches that InstantSearch fires during widget init
                // before the controlled searchState (with URL query) takes effect.

                hasReceivedQuerySearch = false; // Capture the initial URL query at client-creation time so the search proxy
                // can detect spurious empty searches without accessing this.state synchronously.

                initialUrlQuery = (_this$state$searchSta = this.state.searchState) === null || _this$state$searchSta === void 0 ? void 0 : _this$state$searchSta.query;

                client.search = /*#__PURE__*/function () {
                  var _ref2 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2(requests, _) {
                    var _requests$, _requests$$params;

                    var shouldDisableAnalytics, modifiedRequests, requestKey, requestQuery, isRequestQueryEmpty, cachedResult, responsePromise;
                    return _regenerator.default.wrap(function _callee2$(_context2) {
                      while (1) {
                        switch (_context2.prev = _context2.next) {
                          case 0:
                            // Check if we should disable analytics for this search
                            shouldDisableAnalytics = searchState.disableAnalyticsForNextSearch; // Reset the flag after checking - subsequent user searches should track analytics

                            if (searchState.disableAnalyticsForNextSearch) {
                              searchState.disableAnalyticsForNextSearch = false;
                            }

                            modifiedRequests = requests.map(function (request) {
                              var _request$params$query, _request$params, _request$params2, _request$params3;

                              var query = (_request$params$query = request === null || request === void 0 ? void 0 : (_request$params = request.params) === null || _request$params === void 0 ? void 0 : _request$params.query) !== null && _request$params$query !== void 0 ? _request$params$query : '';
                              var isEmptyQuery = !query || query.trim() === ''; // Ensure gs_data_source facet is always included for unified index

                              var facets = request === null || request === void 0 ? void 0 : (_request$params2 = request.params) === null || _request$params2 === void 0 ? void 0 : _request$params2.facets;

                              if (request !== null && request !== void 0 && request.params) {
                                var currentFacets = Array.isArray(facets) ? facets : [];

                                if (!currentFacets.includes('gs_data_source')) {
                                  facets = ['gs_data_source'].concat((0, _toConsumableArray2.default)(currentFacets));
                                }
                              } // Disable analytics for empty queries OR token refresh searches


                              if ((isEmptyQuery || shouldDisableAnalytics) && request !== null && request !== void 0 && request.params) {
                                return _objectSpread(_objectSpread({}, request), {}, {
                                  params: _objectSpread(_objectSpread({}, request.params), {}, {
                                    facets: facets,
                                    analytics: false,
                                    clickAnalytics: false
                                  })
                                });
                              }

                              return facets !== (request === null || request === void 0 ? void 0 : (_request$params3 = request.params) === null || _request$params3 === void 0 ? void 0 : _request$params3.facets) ? _objectSpread(_objectSpread({}, request), {}, {
                                params: _objectSpread(_objectSpread({}, request.params), {}, {
                                  facets: facets
                                })
                              }) : request;
                            }); // Create a cache key from the request parameters (excluding analytics flags)

                            requestKey = JSON.stringify(modifiedRequests.map(function (r) {
                              var _r$params, _r$params2, _r$params3, _r$params4;

                              return {
                                indexName: r.indexName,
                                query: (_r$params = r.params) === null || _r$params === void 0 ? void 0 : _r$params.query,
                                page: (_r$params2 = r.params) === null || _r$params2 === void 0 ? void 0 : _r$params2.page,
                                filters: (_r$params3 = r.params) === null || _r$params3 === void 0 ? void 0 : _r$params3.filters,
                                facetFilters: (_r$params4 = r.params) === null || _r$params4 === void 0 ? void 0 : _r$params4.facetFilters
                              };
                            }));
                            requestQuery = (_requests$ = requests[0]) === null || _requests$ === void 0 ? void 0 : (_requests$$params = _requests$.params) === null || _requests$$params === void 0 ? void 0 : _requests$$params.query;
                            isRequestQueryEmpty = requestQuery === null || requestQuery === undefined || requestQuery === ''; // Skip empty-query searches fired during widget initialization when the URL has a query.
                            // InstantSearch fires 1-2 empty searches before the controlled searchState takes effect.
                            // Once a real (non-empty) search has fired, stop blocking so that clearing the search box works.

                            if (!(isRequestQueryEmpty && !hasReceivedQuerySearch && initialUrlQuery)) {
                              _context2.next = 8;
                              break;
                            }

                            return _context2.abrupt("return", {
                              results: requests.map(function () {
                                return {
                                  hits: [],
                                  nbHits: 0,
                                  page: 0,
                                  nbPages: 0,
                                  hitsPerPage: 20,
                                  processingTimeMS: 0,
                                  query: '',
                                  params: '',
                                  facets: {}
                                };
                              })
                            });

                          case 8:
                            if (!isRequestQueryEmpty) {
                              hasReceivedQuerySearch = true; // Clear empty-query cache — stale after user types a query

                              emptyQueryCache = null;
                            } // Deduplicate identical non-empty searches caused by Preact re-renders.


                            if (!(!isRequestQueryEmpty && requestKey === lastRequestKey && lastResponsePromise)) {
                              _context2.next = 11;
                              break;
                            }

                            return _context2.abrupt("return", lastResponsePromise);

                          case 11:
                            if (!(isRequestQueryEmpty && emptyQueryCache && emptyQueryCache.requestKey === requestKey)) {
                              _context2.next = 17;
                              break;
                            }

                            _context2.next = 14;
                            return emptyQueryCache.responsePromise;

                          case 14:
                            cachedResult = _context2.sent;

                            _this2.extractAndSetTabFacets(emptyQueryCache.fullAlgoliaResponse, emptyQueryCache.tabFacetsRequests);

                            return _context2.abrupt("return", cachedResult);

                          case 17:
                            // Store the request key before making the call (only for non-empty queries)
                            if (!isRequestQueryEmpty) {
                              lastRequestKey = requestKey;
                            } // Create the response promise


                            responsePromise = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
                              var _modifiedRequests$0$p, _modifiedRequests$, _modifiedRequests$$pa, _modifiedRequests$0$p2, _algoliSearchResponse, _modifiedRequests$0$p3, _modifiedRequests$2, _modifiedRequests$2$p, mainFacetFiltersRaw, activeNonSourceFacetFilters, tabFacetsRequests, algoliSearchResponse, originalSearchResults, mainFacetFilters, hasSourceFilter, isAllResultsPage, _mainRequest$params$q, _mainRequest$params, mainRequest, mainQuery, _mainRequest$params$f, _mainRequest$params2, _mainRequest$params$h, _mainRequest$params3, _communityResponse$re, _communityResult$hits, communityResponse, communityResult, _mainRequest$params$h2, _mainRequest$params4, mainResult, hitsPerPage, existingIds, existingFingerprints, newCommunityHits, mergedHits;

                              return _regenerator.default.wrap(function _callee$(_context) {
                                while (1) {
                                  switch (_context.prev = _context.next) {
                                    case 0:
                                      _context.prev = 0;
                                      // Extract non-source facetFilters from the main request (category, content_type, tags, etc.)
                                      // so tab facet counts reflect the user's active sidebar filters.
                                      // Source-related filters (gs_data_source, source) are excluded since each tab query has its own.
                                      mainFacetFiltersRaw = (_modifiedRequests$0$p = (_modifiedRequests$ = modifiedRequests[0]) === null || _modifiedRequests$ === void 0 ? void 0 : (_modifiedRequests$$pa = _modifiedRequests$.params) === null || _modifiedRequests$$pa === void 0 ? void 0 : _modifiedRequests$$pa.facetFilters) !== null && _modifiedRequests$0$p !== void 0 ? _modifiedRequests$0$p : [];
                                      activeNonSourceFacetFilters = mainFacetFiltersRaw.filter(function (f) {
                                        if (typeof f === 'string') {
                                          return !f.startsWith('gs_data_source:') && !f.startsWith('source:');
                                        }

                                        if (Array.isArray(f)) {
                                          return !f.some(function (ff) {
                                            return ff.startsWith('gs_data_source:') || ff.startsWith('source:');
                                          });
                                        }

                                        return true;
                                      });
                                      tabFacetsRequests = (0, _utils.buildTabFacetsRequests)((_modifiedRequests$0$p2 = modifiedRequests[0].params.query) !== null && _modifiedRequests$0$p2 !== void 0 ? _modifiedRequests$0$p2 : '', // Filtering indexNames based on feature availability to get tab facets of enabled indexes only
                                      indexNames.filter(function (indexName) {
                                        if (indexName.endsWith('skilljar') && !_this2.props.isFederatedSkilljarSearch) return false;
                                        if (indexName.endsWith('salesforce') && !_this2.props.isFederatedSalesforceSearch) return false;
                                        if (indexName.endsWith('freshdesk') && !_this2.props.isFederatedFreshdeskSearch) return false; // TODO: isZendeskFederatedSearchEnabled is available in searchToken response and not in props, not sure why.

                                        if (indexName.endsWith('zendesk') && !response.isZendeskFederatedSearchEnabled) return false;
                                        return true;
                                      }), _this2.includedDataSources, response.hiddenCategories, activeNonSourceFacetFilters, _this2.heroFilters);
                                      _context.next = 6;
                                      return originalSearch([].concat((0, _toConsumableArray2.default)(modifiedRequests), (0, _toConsumableArray2.default)(tabFacetsRequests)));

                                    case 6:
                                      algoliSearchResponse = _context.sent;

                                      // Populate empty-query cache with data needed for dedup (extractAndSetTabFacets on cache hit)
                                      if (isRequestQueryEmpty && emptyQueryCache) {
                                        emptyQueryCache.fullAlgoliaResponse = algoliSearchResponse;
                                        emptyQueryCache.tabFacetsRequests = tabFacetsRequests;
                                      }

                                      _this2.extractAndSetTabFacets(algoliSearchResponse, tabFacetsRequests); // Returning the results of original requests (removing tab facets data from here)


                                      originalSearchResults = (_algoliSearchResponse = algoliSearchResponse.results) === null || _algoliSearchResponse === void 0 ? void 0 : _algoliSearchResponse.slice(0, 0 - tabFacetsRequests.length); // On All Results page, the main search may not return community results
                                      // due to Algolia's distinct behavior on the unified index.
                                      // Fetch community results separately and merge them into the main response.
                                      // Detect All Results page from request params (no source/content_type/gs_data_source facetFilters)

                                      mainFacetFilters = (_modifiedRequests$0$p3 = (_modifiedRequests$2 = modifiedRequests[0]) === null || _modifiedRequests$2 === void 0 ? void 0 : (_modifiedRequests$2$p = _modifiedRequests$2.params) === null || _modifiedRequests$2$p === void 0 ? void 0 : _modifiedRequests$2$p.facetFilters) !== null && _modifiedRequests$0$p3 !== void 0 ? _modifiedRequests$0$p3 : [];
                                      hasSourceFilter = mainFacetFilters.some(function (f) {
                                        return typeof f === 'string' && (f.startsWith('source:') || f.startsWith('content_type:') || f.startsWith('gs_data_source:')) || Array.isArray(f) && f.some(function (ff) {
                                          return ff.startsWith('source:') || ff.startsWith('content_type:') || ff.startsWith('gs_data_source:');
                                        });
                                      });
                                      isAllResultsPage = !hasSourceFilter;

                                      if (!(isAllResultsPage && originalSearchResults !== null && originalSearchResults !== void 0 && originalSearchResults.length)) {
                                        _context.next = 27;
                                        break;
                                      }

                                      mainRequest = modifiedRequests[0];
                                      mainQuery = (_mainRequest$params$q = (_mainRequest$params = mainRequest.params) === null || _mainRequest$params === void 0 ? void 0 : _mainRequest$params.query) !== null && _mainRequest$params$q !== void 0 ? _mainRequest$params$q : ''; // Skip community merge for empty queries (default/browse results)

                                      if (!mainQuery) {
                                        _context.next = 27;
                                        break;
                                      }

                                      _context.prev = 17;
                                      _context.next = 20;
                                      return originalSearch([{
                                        indexName: mainRequest.indexName,
                                        query: mainQuery,
                                        params: _objectSpread(_objectSpread({}, mainRequest.params), {}, {
                                          facetFilters: [].concat((0, _toConsumableArray2.default)((_mainRequest$params$f = (_mainRequest$params2 = mainRequest.params) === null || _mainRequest$params2 === void 0 ? void 0 : _mainRequest$params2.facetFilters) !== null && _mainRequest$params$f !== void 0 ? _mainRequest$params$f : []), ['gs_data_source:community']),
                                          hitsPerPage: (_mainRequest$params$h = (_mainRequest$params3 = mainRequest.params) === null || _mainRequest$params3 === void 0 ? void 0 : _mainRequest$params3.hitsPerPage) !== null && _mainRequest$params$h !== void 0 ? _mainRequest$params$h : 20,
                                          analytics: false,
                                          clickAnalytics: false
                                        })
                                      }]);

                                    case 20:
                                      communityResponse = _context.sent;
                                      communityResult = (_communityResponse$re = communityResponse.results) === null || _communityResponse$re === void 0 ? void 0 : _communityResponse$re[0];

                                      if (communityResult !== null && communityResult !== void 0 && (_communityResult$hits = communityResult.hits) !== null && _communityResult$hits !== void 0 && _communityResult$hits.length) {
                                        mainResult = originalSearchResults[0];
                                        hitsPerPage = (_mainRequest$params$h2 = (_mainRequest$params4 = mainRequest.params) === null || _mainRequest$params4 === void 0 ? void 0 : _mainRequest$params4.hitsPerPage) !== null && _mainRequest$params$h2 !== void 0 ? _mainRequest$params$h2 : 20; // Deduplicate by objectID and content fingerprint (title + url) to catch
                                        // the same content indexed with different objectIDs

                                        existingIds = new Set(mainResult.hits.map(function (h) {
                                          return h.objectID;
                                        }));
                                        existingFingerprints = new Set(mainResult.hits.map(function (h) {
                                          var _h$title, _h$url;

                                          return "".concat((_h$title = h.title) !== null && _h$title !== void 0 ? _h$title : '', "|").concat((_h$url = h.url) !== null && _h$url !== void 0 ? _h$url : '');
                                        }));
                                        newCommunityHits = communityResult.hits.filter(function (h) {
                                          var _h$title2, _h$url2;

                                          if (existingIds.has(h.objectID)) return false;
                                          var fingerprint = "".concat((_h$title2 = h.title) !== null && _h$title2 !== void 0 ? _h$title2 : '', "|").concat((_h$url2 = h.url) !== null && _h$url2 !== void 0 ? _h$url2 : '');
                                          if (existingFingerprints.has(fingerprint)) return false;
                                          existingIds.add(h.objectID);
                                          existingFingerprints.add(fingerprint);
                                          return true;
                                        }); // Merge and cap at hitsPerPage to maintain consistent page size

                                        mergedHits = [].concat((0, _toConsumableArray2.default)(mainResult.hits), (0, _toConsumableArray2.default)(newCommunityHits)).slice(0, hitsPerPage);
                                        mainResult.hits = mergedHits; // Add community total to nbHits. Don't subtract per-page duplicateCount —
                                        // it varies per page and causes the displayed total to fluctuate on scroll.
                                        // The display logic in getTotalTopicsCount uses Math.min(nbHits, tabFacetsTotal)
                                        // which already caps any inflation.

                                        mainResult.nbHits = (mainResult.nbHits || 0) + (communityResult.nbHits || 0);
                                        mainResult.nbPages = Math.max(mainResult.nbPages || 0, communityResult.nbPages || 0);
                                      }

                                      _context.next = 27;
                                      break;

                                    case 25:
                                      _context.prev = 25;
                                      _context.t0 = _context["catch"](17);

                                    case 27:
                                      return _context.abrupt("return", {
                                        results: originalSearchResults
                                      });

                                    case 30:
                                      _context.prev = 30;
                                      _context.t1 = _context["catch"](0);
                                      // Clear cache on error so next identical request retries
                                      lastRequestKey = null;
                                      lastResponsePromise = null;
                                      emptyQueryCache = null;
                                      throw _context.t1;

                                    case 36:
                                    case "end":
                                      return _context.stop();
                                  }
                                }
                              }, _callee, null, [[0, 30], [17, 25]]);
                            }))(); // Cache response to deduplicate subsequent identical requests

                            if (!isRequestQueryEmpty) {
                              lastResponsePromise = responsePromise;
                            } else {
                              // Set cache synchronously so subsequent calls (before this one resolves) hit the cache.
                              // fullAlgoliaResponse and tabFacetsRequests are populated inside the IIFE after the await.
                              emptyQueryCache = {
                                requestKey: requestKey,
                                responsePromise: responsePromise,
                                fullAlgoliaResponse: null,
                                tabFacetsRequests: []
                              };
                            }

                            return _context2.abrupt("return", responsePromise);

                          case 21:
                          case "end":
                            return _context2.stop();
                        }
                      }
                    }, _callee2);
                  }));

                  return function (_x2, _x3) {
                    return _ref2.apply(this, arguments);
                  };
                }(); // Set client state AFTER wrapping search method to ensure wrapped client is used


                this.setState({
                  // eslint: fix for object-shorthand
                  client: client,
                  hiddenCategories: response.hiddenCategories,
                  isZendeskFederatedSearch: response.isZendeskFederatedSearchEnabled
                });
                (0, _algoliaService.insights)('init', {
                  appId: response.client_id,
                  apiKey: response.token
                });

              case 19:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function cb(_x) {
        return _cb.apply(this, arguments);
      }

      return cb;
    }()
  }, {
    key: "includedDataSources",
    get: function get() {
      var dataSources = {
        skilljar: this.props.isFederatedSkilljarSearch,
        salesforce: this.props.isFederatedSalesforceSearch,
        freshdesk: this.props.isFederatedFreshdeskSearch,
        zendesk: this.state.isZendeskFederatedSearch,
        federated: isFederatedSearchEnabled()
      };
      return Object.keys(dataSources).filter(function (key) {
        return dataSources[key];
      });
    }
    /**
     *
     * @description Extract tabFacets data from the algolia response and set it in the searchService
     */

  }, {
    key: "extractAndSetTabFacets",
    value: function extractAndSetTabFacets(algoliaSearchResponse, tabFacetsRequests) {
      var _algoliaSearchRespons, _this$state$searchSta2, _this$state$searchSta3, _this$state$searchSta4, _this$state$searchSta5, _this$state$searchSta6, _this$state$searchSta7;

      var tabFacetsResponse = (_algoliaSearchRespons = algoliaSearchResponse.results) === null || _algoliaSearchRespons === void 0 ? void 0 : _algoliaSearchRespons.slice(0 - tabFacetsRequests.length);
      var selectedSource = (_this$state$searchSta2 = this.state.searchState.refinementList) === null || _this$state$searchSta2 === void 0 ? void 0 : (_this$state$searchSta3 = _this$state$searchSta2.source) === null || _this$state$searchSta3 === void 0 ? void 0 : _this$state$searchSta3[0];
      var selectedContentType = (_this$state$searchSta4 = this.state.searchState.refinementList) === null || _this$state$searchSta4 === void 0 ? void 0 : (_this$state$searchSta5 = _this$state$searchSta4.content_type) === null || _this$state$searchSta5 === void 0 ? void 0 : _this$state$searchSta5[0];
      var selectedGsDataSource = (_this$state$searchSta6 = this.state.searchState.refinementList) === null || _this$state$searchSta6 === void 0 ? void 0 : (_this$state$searchSta7 = _this$state$searchSta6.gs_data_source) === null || _this$state$searchSta7 === void 0 ? void 0 : _this$state$searchSta7[0];
      (0, _utils.buildTabFacets)({
        tabFacetsResponse: tabFacetsResponse,
        selectedSource: selectedSource,
        _selectedContentType: selectedContentType,
        selectedGsDataSource: selectedGsDataSource
      });
    }
  }, {
    key: "componentDidMount",
    value: function () {
      var _componentDidMount = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee4() {
        var _this3 = this;

        return _regenerator.default.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return (0, _algoliaService.getSearchToken)(function (c) {
                  _this3.cb(c);
                });

              case 2:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }));

      function componentDidMount() {
        return _componentDidMount.apply(this, arguments);
      }

      return componentDidMount;
    }()
  }, {
    key: "resetSources",
    value: function resetSources() {
      this.setState({
        sourceTabs: {},
        pageCount: 0
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$state$searchSta8,
          _this4 = this,
          _refinementList$sourc;

      var _this$props = this.props,
          defaultCdn = _this$props.defaultCdn,
          attachmentCdn = _this$props.attachmentCdn,
          aiSearchSummary = _this$props.aiSearchSummary,
          askAISearchSummary = _this$props.askAISearchSummary,
          aiSmartSearchEnableForAllRoles = _this$props.aiSmartSearchEnableForAllRoles,
          isGuest = _this$props.isGuest,
          isFederatedSalesforceSearch = _this$props.isFederatedSalesforceSearch,
          isFederatedSkilljarSearch = _this$props.isFederatedSkilljarSearch,
          isFederatedFreshdeskSearch = _this$props.isFederatedFreshdeskSearch,
          displayKnowledgeBaseCategories = _this$props.displayKnowledgeBaseCategories,
          timeConfig = _this$props.timeConfig,
          forethoughtAgent = _this$props.forethoughtAgent,
          forethoughtAgentSelected = _this$props.forethoughtAgentSelected;
      var _this$state = this.state,
          client = _this$state.client,
          enableLoader = _this$state.enableLoader,
          isFiltersOverlay = _this$state.isFiltersOverlay,
          pageCount = _this$state.pageCount,
          totalAmount = _this$state.totalAmount,
          isKnowledgeBaseActive = _this$state.isKnowledgeBaseActive,
          sourceTabs = _this$state.sourceTabs,
          listIndexes = _this$state.listIndexes,
          isZendeskFederatedSearch = _this$state.isZendeskFederatedSearch,
          hiddenCategories = _this$state.hiddenCategories;

      if (!client) {
        return null;
      }

      var enabledSources = Object.keys(sourceTabs).filter(function (key) {
        return sourceTabs[key];
      });
      var sourceFilters = enabledSources.map(function (enabledSource) {
        return "source: ".concat(enabledSource);
      });
      var externalSourcesEnabled = isZendeskFederatedSearch || isFederatedSalesforceSearch || isFederatedSkilljarSearch || isFederatedFreshdeskSearch || isFederatedSearchEnabled();
      var refinementList = this.state.searchState.refinementList;
      var searchQuery = (_this$state$searchSta8 = this.state.searchState.query) !== null && _this$state$searchSta8 !== void 0 ? _this$state$searchSta8 : ''; // Show sidebar always when unified index is enabled

      var showSidebar = true; // when unified index is enabled, we depend on gs_data_source & source to check if a tab is selected. Else, we use content_type & source
      // when none of the above facets are selected, we are in all results page.

      var isAllResultsPage = (!(refinementList !== null && refinementList !== void 0 && refinementList.source) || refinementList.source.length === 0) && (!(refinementList !== null && refinementList !== void 0 && refinementList.gs_data_source) || refinementList.gs_data_source.length === 0); // AI Answers vs Forethought precedence:
      //   - When the community has selected Forethought (admin flag on),
      //     Forethought OWNS the AI surface. Even if a particular viewer doesn't
      //     satisfy the shared role gate, AI Answers does NOT fall back in —
      //     admins picked Forethought as THE AI experience for this community.
      //   - AI Answers renders only when Forethought is not selected.
      // Both surfaces require the Search Summary master (`aiSearchSummary`) to be
      // on and share `aiSmartSearchEnableForAllRoles` as the all-roles gate.

      var sharedRoleGate = !isGuest || !!aiSmartSearchEnableForAllRoles;
      var summaryGatesPass = aiSearchSummary && sharedRoleGate;
      var showForethought = !!forethoughtAgent && summaryGatesPass;
      var showForethoughtMisconfig = !showForethought && !!forethoughtAgentSelected && summaryGatesPass; // Forethought selection suppresses AI Answers community-wide. Misconfig is
      // a sub-case of "Forethought selected" so it's covered by the same guard.

      var showAiAnswers = !forethoughtAgentSelected && askAISearchSummary && summaryGatesPass;
      return (0, _preact.h)("div", {
        className: "instant-search-wrapper unified-index-enabled"
      }, (0, _preact.h)(_components.InstantSearch, {
        searchClient: this.state.client,
        indexName: COMMUNITY_ID,
        searchState: this.state.searchState,
        onSearchStateChange: this.handleStateChange
      }, (0, _preact.h)(_Indexes.default, {
        listIndexes: listIndexes,
        communityId: COMMUNITY_ID,
        externalSourcesEnabled: externalSourcesEnabled,
        pageCount: pageCount,
        sourceFilters: sourceFilters,
        hiddenCategories: hiddenCategories,
        isZendeskFederatedSearch: isZendeskFederatedSearch,
        enabledSources: enabledSources,
        isFederatedSalesforceSearch: isFederatedSalesforceSearch,
        isFederatedSkilljarSearch: isFederatedSkilljarSearch,
        isFederatedFreshdeskSearch: isFederatedFreshdeskSearch,
        isFederatedSearchEnabled: isFederatedSearchEnabled(),
        includedDataSources: this.includedDataSources,
        searchInContentCategories: this.heroFilters.searchInContentCategories,
        searchInProductAreas: this.heroFilters.searchInProductAreas
      }), (0, _preact.h)("div", {
        className: "instant-search-input-wrapper"
      }, (0, _preact.h)(_SearchBox.default, {
        defaultCdn: defaultCdn,
        enableLoader: enableLoader,
        loaderCallback: function loaderCallback() {
          return _this4.setState({
            enableLoader: true
          });
        }
      }), showSidebar && (0, _preact.h)(_components2.InstantSearchFilterButton, {
        onClick: this.handleFilterChange
      })), (0, _preact.h)(SkipToSearch, null), showForethought && (0, _preact.h)(_ForethoughtAgent.default, null), showForethoughtMisconfig && (0, _preact.h)("div", {
        className: "forethought-agent forethought-agent--misconfigured",
        role: "alert"
      }, (0, _preact.h)("div", {
        className: "forethought-agent__error"
      }, "The AI assistant is temporarily unavailable. Please contact support if the issue persists.")), showAiAnswers && (0, _preact.h)(_SmartSummary.default, {
        hiddenCategories: hiddenCategories,
        includedDataSources: this.includedDataSources
      }), searchQuery && (showForethought || showForethoughtMisconfig || showAiAnswers) && (0, _preact.h)("div", {
        className: "search-query-info"
      }, (0, _preact.h)(_phrase.default, {
        p: "search.ai.answers.searchResultsFor"
      }), " : ", searchQuery), (0, _preact.h)(_FilterTabs.default, {
        onFilterTabChange: this.onFilterTabChange
      }), (0, _preact.h)(SkipToSearch, null), (0, _preact.h)("div", {
        className: "instant-search__results-wrapper"
      }, showSidebar && (0, _preact.h)(_Sidebar.Sidebar, {
        isFiltersOverlay: isFiltersOverlay,
        handleFilterChange: this.handleFilterChange,
        isKnowledgeBaseActive: isKnowledgeBaseActive,
        displayKnowledgeBaseCategories: displayKnowledgeBaseCategories,
        totalAmount: totalAmount,
        clearAllFilters: this.clearSidebarFilters,
        searchState: this.state.searchState,
        communityId: COMMUNITY_ID,
        isZendeskFederatedSearch: isZendeskFederatedSearch && listIndexes.includes("".concat(COMMUNITY_ID, "-zendesk")),
        selectedSource: refinementList === null || refinementList === void 0 ? void 0 : (_refinementList$sourc = refinementList.source) === null || _refinementList$sourc === void 0 ? void 0 : _refinementList$sourc[0]
      }), (0, _preact.h)("div", {
        className: (0, _classnames.default)('col', 'col--main', 'has--side', 'search-topic-list-wrapper')
      }, (0, _preact.h)(_Results.SearchResults, {
        aiSearchSummary: aiSearchSummary,
        communityId: COMMUNITY_ID,
        attachmentCdn: attachmentCdn,
        enableLoader: enableLoader,
        isZendeskFederatedSearch: isZendeskFederatedSearch,
        isFederatedSalesforceSearch: isFederatedSalesforceSearch,
        isFederatedSkilljarSearch: isFederatedSkilljarSearch,
        isFederatedFreshdeskSearch: isFederatedFreshdeskSearch,
        isFederatedSearch: isFederatedSearchEnabled(),
        pageCount: pageCount,
        loadNextPage: function loadNextPage() {
          return _this4.setState({
            pageCount: pageCount + 1
          });
        },
        loaderCallback: function loaderCallback(enableLoader) {
          // eslint: fix for object-shorthand
          return _this4.setState({
            enableLoader: enableLoader
          });
        },
        totalTopicsAmount: this.totalTopicsAmount,
        isAllResultsPage: isAllResultsPage,
        onAllResultsSectionClick: this.onAllResultsSectionClick,
        timeConfig: timeConfig
      })))));
    }
  }]);
  return InstantSearchComponent;
}(_preact.Component);

var _default = InstantSearchComponent;
exports.default = _default;
var cssAnchorName = 'instant-search-v2';
exports.cssAnchorName = cssAnchorName;

var SkipToSearch = function SkipToSearch() {
  return (0, _preact.h)("a", {
    href: "#search-results-container",
    className: "skip-link"
  }, (0, _preact.h)(_phrase.default, {
    p: "search.skip_to_results"
  }));
};